import { render, staticRenderFns } from "./ResultItem.vue?vue&type=template&id=1dbadbb4"
import script from "./ResultItem.vue?vue&type=script&lang=js"
export * from "./ResultItem.vue?vue&type=script&lang=js"
import style0 from "./ResultItem.vue?vue&type=style&index=0&id=1dbadbb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports